import { Flex, Box, Text, SlideFade } from "@chakra-ui/react";
import { useRouter } from "next/router";
import Head from "next/head";
import Layout from "components/Layout";
import Image from "components/Image";
import discoverImage from "../../../public/approach/discover.png";
import partnerCoCreateImage from "../../../public/approach/partner-co-create.png";
import launchImage from "../../../public/approach/launch.png";
import bgCircleTop from "../../../public/approach/bg-circle-top.png";
import bgCircleCenter from "../../../public/approach/bg-circle-center.png";
import FooterHalfCircle from "containers/FooterHalfCircle";

const discoverPartnerLaunchData = [
  {
    number: "01",
    title: "Discover",
    desc: "The discovery phase helps us set expectations. You provide the vision for product delivery and customer experience. And we craft the team, solution, and roadmap to get there.",
    img: discoverImage,
    imgAltText: "Strategist taking a sticky note off the board",
  },
  {
    number: "02",
    title: "Partner & Co-create",
    desc: "This is where vision and technology come together. We co-create the product by leveraging pre-built architectures and proven methodologies. Working as one team, we learn, iterate, and deliver.",
    img: partnerCoCreateImage,
    imgAltText: "group of colleagues planning product launch",
  },
  {
    number: "03",
    title: "Launch",
    desc: "It’s time to go to market! Before launch, the product is tested by real users, so we get a feel for their expectations. After that, its continuous improvement until we achieve the best product experience.",
    img: launchImage,
    imgAltText: "developer testing the launched application",
  },
];

const Approach = () => {
  const router = useRouter();

  return (
    <Layout>
      <Head>
        <title>101Digital | Approach</title>
      </Head>
      <SlideFade in={true} offsetY='50px' transition={{enter:{duration:1}}} >
      <Text
        as="h1"
        textStyle="h1"
        textAlign={["center", null, null, null, null, "left"]}
        display="flex"
        flexDir={["column", null, null, null, null, "row"]}
        mb={["13px", null, null, null, null, "32px"]}
        mt={["45px", null, null, null, null, "132px"]}
      >
       
          <Text display={["none", null, null, null, null, "flex"]}>
            <Text>The</Text>
            <Text color="secondary" mx="8px">
              101 Digital
            </Text>
            <Text>Way</Text>
            </Text>
       
            <Text display={["inline", null, null, null, null, "none"]}>
            <Flex justify="center">
              <Text>The</Text>
              <Text color="secondary" ml="8px">
                101
              </Text>
            </Flex>
            <Flex justify="center">
              <Text color="secondary" mr="8px">
                Digital
              </Text>
              <Text>Way</Text>
            </Flex>
            </Text>
      
        
      </Text>
      </SlideFade>
      <Text
        textStyle="paragraphHighlighted"
        textAlign={["center", null, null, null, null, "left"]}
        px={["61px", null, null, null, null, 0]}
        mb={["37.35px", null, null, null, null, "120px"]}
        fontSize={["16px", null, null, null, null, "24px"]}
        fontWeight="300"
      >
        An approach empowered by industry experience, work principle and agile
        technology.
      </Text>
      <Flex>
        <Flex
          w={["0%", null, null, null, null, "50%"]}
          bgImage="url('/circuit-board-white-small.png')"
        />
        <Flex
          w={["100%", null, null, null, null, "50%"]}
          bgColor="primary"
          bgImage="url('/circuit-board-blue-small.png')"
          p={[
            "49.65px 129px 53px 21.48px",
            null,
            null,
            null,
            null,
            "80px 1rem 120px 12px",
            "125px 8rem 120px 104px",
            "125px 8rem 120px 104px",
            "125px 19rem 120px 104px",
            "125px 378px 120px 104px",
          ]}
        >
        <SlideFade in={true} offsetX='200px' transition={{enter:{duration:1}}}>
          <Text
            color="white"
            fontSize={["14px", null, null, null, null, "24px"]}
          >
            Our collaborations are more than project scope and timelines. We
            take what we are good at - building exceptional digital financial
            products, and apply our skills to your ecosystem. So you can focus
            on customers and not worry about product delivery.
          </Text>
          </SlideFade>
        </Flex>
      </Flex>

      {/* SECTION Discover, partner, launch! */}
      <Box
        w="100%"
        p={[
          "46px 16px 0",
          null,
          null,
          null,
          null,
          "130px 16px 124px",
          "130px 16px 60px",
          null,
          null,
          "130px 16px 60px",
        ]}
        mb="-7px"
        position="relative"
      >
        <Box
          position="absolute"
          top="30px"
          right="0"
          pointerEvents="none"
          zIndex={-1}
          display={["none", "block"]}
        >
          <Image src={bgCircleTop} alt="" />
        </Box>
        <Box
          position="absolute"
          top={["1%", "20%"]}
          left={["-20%", "0"]}
          pointerEvents="none"
          zIndex={-1}
          width={["220px", "auto"]}
        >
          <Image src={bgCircleCenter} alt="" />
        </Box>
        {/* <Box position="absolute" bottom={["23%", "0"]} right={["-12%", "0"]} pointerEvents="none" zIndex={-1} width={["360px", "auto"]}>
          <Image src={bgCircleBottom} alt="" />
        </Box> */}
        <Text
          as="h2"
          textStyle="h2"
          textAlign="center"
          mb={["61px", null, null, null, null, "96px"]}
          fontWeight="300"
          fontSize={["18px", null, null, null, null, "48px"]}
        >
          Discover, partner, launch!
        </Text>

        <Box mx="auto" w="100%" maxW="1137px">
          {discoverPartnerLaunchData.map((part, i) => (
            <Box
              key={part.number}
              mb={[
                "0",
                null,
                null,
                null,
                null,
                i !== discoverPartnerLaunchData.length - 1 ? "150px" : "0",
              ]}
              px="16px"
            >
              <Flex
                w="100%"
                flexDir={[
                  "column",
                  null,
                  null,
                  null,
                  null,
                  i % 2 !== 0 ? "row-reverse" : "row",
                ]}
                alignItems={["center", null, null, null, null, "initial"]}
                justify={["space-between"]}
              >
                <Box>
                  <Flex
                    w={["56px", null, null, null, null, "75px"]}
                    h={["56px", null, null, null, null, "75px"]}
                    justify="center"
                    alignItems="center"
                    boxShadow="10px 3px 12px rgba(207, 207, 207, 0.4)"
                    bgColor="#ffffff"
                    color="primary"
                    mx={["auto", null, null, null, null, "unset"]}
                    borderRadius={[
                      "19.3455px",
                      null,
                      null,
                      null,
                      null,
                      "25.8989px",
                    ]}
                    fontSize={["18.33px", null, null, null, null, "24.54px"]}
                    fontWeight="400"
                    mb={["40px", null, null, null, null, "30.03px"]}
                  >
                    {part.number}
                  </Flex>
                  <Box
                    display={["block", null, null, null, null, "none"]}
                    position="relative"
                    width={"100%"}
                  >
                    <Image src={part.img} alt={part.imgAltText} />
                    <Text
                      display={["block", null, null, null, null, "none"]}
                      textAlign="center"
                      whiteSpace="nowrap"
                      fontSize="18px"
                      color="#fff"
                      position="absolute"
                      bottom="20px"
                      left="50%"
                      transform="translateX(-50%)"
                    >
                      {part.title}
                    </Text>
                  </Box>
                  <Text
                    fontSize="36px"
                    fontWeight="300"
                    mb="15.38px"
                    color="primary"
                    display={["none", null, null, null, null, "block"]}
                  >
                    {part.title}
                  </Text>
                  <Text
                    fontSize={["14px", null, null, null, null, "21px"]}
                    mt={["55px", null, null, null, null, 0]}
                    mx={["auto", null, null, null, null, "unset"]}
                    mb="55px"
                    p={["0 20px", null, null, null, null, 0]}
                    color="gray"
                    fontWeight="300"
                    textAlign={["center", null, null, null, null, "initial"]}
                    maxW="400px"
                  >
                    {part.desc}
                  </Text>
                </Box>
                <Box
                  display={["none", null, null, null, null, "block"]}
                  position="relative"
                  flex={["0 0 595px"]}
                  maxW={["595px"]}
                  mr={[i % 2 !== 0 ? "24px" : "0"]}
                  ml={[i % 2 === 0 ? "24px" : "0"]}
                >
                  <Image src={part.img} alt={part.imgAltText} />
                  <Text
                    display={["block", null, null, null, null, "none"]}
                    fontSize="18px"
                    color="#fff"
                    position="absolute"
                    bottom="20px"
                    left="50%"
                    transform="translateX(-50%)"
                  >
                    {part.title}
                  </Text>
                </Box>
              </Flex>
            </Box>
          ))}
        </Box>
      </Box>

      {/* END SECTION Discover, partner, launch! */}

      {/* 6TH SECTION */}
      <FooterHalfCircle
        title="A product suite to match our approach"
        description="Our products, catered to any bank and fintech use case, work perfectly with our approach to delivering customer success."
        buttonTitle="See what we built"
        buttonLink="/products"
      />

      {/* SECTION A Product suite... */}
      {/* <PreFooter
        title="A product suite to match our approach"
        image={twoFactorsImage}
        button={{ label: "See what we built", onClick: () => {} }}
      /> */}
      {/* END SECTION A Product suite... */}
    </Layout>
  );
};

export default Approach;
